import type { LeaveTypesRepositoryT } from "../../domain/ports/leaveTypes.repository";

type ToggleLeaveTypeActiveStatusParamsT = {
  leaveTypesRepository: LeaveTypesRepositoryT;
  typeId: string;
  isActive: boolean;
  colaboraInstanceId: string;
};

export const toggleLeaveTypeActiveStatus = async ({
  leaveTypesRepository,
  typeId,
  isActive,
  colaboraInstanceId,
}: ToggleLeaveTypeActiveStatusParamsT) => {
  await leaveTypesRepository.toggleActiveStatus(typeId, isActive, colaboraInstanceId);
};
